import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import UsersApi from 'apis/Users';
import UsersList from 'components/users/UsersList';
import Loading from 'utils/Loading';
import 'assets/scss/business.css';
import 'assets/scss/table.css';

class Users extends Component {
  constructor() {
    super();
    this.state = {
      searchText: '',
      users: [],
      isLoading: true,
    };
  }

  componentDidMount = () => {
    UsersApi.getAll()
      .then(({ data }) => {
        this.setState({ users: data, isLoading: false });
      })
      .catch(console.log);
  };

  handleFilterInput = e => {
    const { value } = e.target;

    this.setState({ searchText: value });
  };

  render() {
    const { isLoading, searchText, users } = this.state;

    if (isLoading) {
      return <Loading />;
    }

    return (
      <div className="container">
        <div className="row mb-4 justify-content-end">
          <div className="col-lg-3 col-md-2 user-count justify-content-start">
            <span className="count-container">{users.length}</span>
          </div>
          <div className="col-lg-9 col-md-10 input-group business-search justify-content-end">
            <input
              className="col-lg-3 col-md-12 form-control search-text-box"
              placeholder="Enter search keyword"
              value={searchText}
              onChange={this.handleFilterInput}
            />
            <div className="input-group-append">
              <button className="btn btn-add-new">
                <FontAwesomeIcon icon="search" />
                Search
              </button>
            </div>
          </div>
        </div>
        <UsersList searchText={searchText} users={users} />
      </div>
    );
  }
}

export default Users;



// WEBPACK FOOTER //
// ./src/containers/Users.js